import { call, put } from "redux-saga/effects";
import {
  fetchOfficeCollectionMappingSuccess,
  importFileFailed,
  importFileSuccess,
} from "./actions";
import { showErrorNotification } from "src/util/notifications";
import api from "src/util/api";
import {
  FRAME_ARRANGER_QTY_URL,
  OFFICE_COLLECTION_URL,
  VENDOR_COLLECTION_URL,
} from "src/util/constants/api.constants";

const officeCollectionFilterDataCache = new Map<string, any[]>();

export function* fetchOfficeCollectionMapping({ payload }: any): Generator {
  try {
    const isLegacyPayload = typeof payload === "boolean";
    const isActive = isLegacyPayload ? payload : payload?.isActive ?? true;
    const pageNumber = isLegacyPayload ? 1 : payload?.pageNumber ?? 1;
    const pageSize = isLegacyPayload ? 10 : payload?.pageSize ?? 10;
    const filters = isLegacyPayload ? [] : payload?.filters ?? [];
    const sorting = isLegacyPayload ? [] : payload?.sorting ?? [];
    let url = OFFICE_COLLECTION_URL.OFFICE_COLLECTION_LIST + isActive;

    const queryParts = [
      `pageNumber=${encodeURIComponent(String(pageNumber))}`,
      `pageSize=${encodeURIComponent(String(pageSize))}`,
    ];

    if (Array.isArray(filters) && filters.length > 0) {
      queryParts.push(`filters=${encodeURIComponent(JSON.stringify(filters))}`);
    }

    if (Array.isArray(sorting) && sorting.length > 0) {
      queryParts.push(`sortBy=${encodeURIComponent(sorting[0]?.id ?? "")}`);
      queryParts.push(
        `sortDirection=${encodeURIComponent(
          sorting[0]?.desc ? "desc" : "asc"
        )}`
      );
    }

    const requestUrl = `${url}?${queryParts.join("&")}`;
    const data: any = yield call(api.get, requestUrl);
    yield put(fetchOfficeCollectionMappingSuccess(data));
  } catch (e: any) {
    showErrorNotification(null, e);
  }
}

export function saveOfficeCollectionMapping(payload: any) {
  let url = `${OFFICE_COLLECTION_URL.OFFICE_COLLECTION_SAVE}`;
  return api.post(url, payload);
}

export function updateOfficeCollectionMapping(payload: any) {
  let url = `${OFFICE_COLLECTION_URL.OFFICE_COLLECTION_SAVE}`;
  return api.put(url, payload);
}

export function bulkEditOfficeColletion(payload: any) {
  let url = `${OFFICE_COLLECTION_URL.BULK_EDIT}`;
  return api.put(url, payload);
}
export function closeOffice(payload: any) {
  let url = `${OFFICE_COLLECTION_URL.CLOSE_OC}`;
  return api.post(url, payload);
}

export function getCollectionType() {
  let url = `${OFFICE_COLLECTION_URL.COLLECTION_TYPE_LIST}`;
  return api.get(url);
}

export function getFADetail(payload: any) {
  let url = OFFICE_COLLECTION_URL.EDIT_OC + payload;
  return api.get(url);
}

export function getFrameCollection(payload: any) {
  let url = `${FRAME_ARRANGER_QTY_URL.FRAME_ARRANGER_QTY_LIST}`;
  return api.post(url, payload);
}

export function getFrameCollectionForOffice(payload: any) {
  let url = FRAME_ARRANGER_QTY_URL.FRAME_ARRANGER_LIST_FOR_OFFICE + payload;
  return api.get(url);
}

export async function getOfficeCollectionFilterData(isActive: boolean) {
  const cacheKey = `isActive:${isActive}`;
  const cachedData = officeCollectionFilterDataCache.get(cacheKey);
  if (cachedData && cachedData.length > 0) {
    return cachedData;
  }

  const pageSize = 10000;
  const maxPages = 100;
  let pageNumber = 1;
  let totalCount = 0;
  let allItems: any[] = [];

  while (pageNumber <= maxPages) {
    const url =
      `${OFFICE_COLLECTION_URL.OFFICE_COLLECTION_LIST}${isActive}` +
      `?pageNumber=${encodeURIComponent(String(pageNumber))}` +
      `&pageSize=${encodeURIComponent(String(pageSize))}`;
    const response: any = await api.get(url);
    const items = Array.isArray(response)
      ? response
      : response?.Items ?? response?.items ?? [];

    if (!Array.isArray(items) || items.length === 0) {
      break;
    }

    allItems = allItems.concat(items);

    totalCount = Array.isArray(response)
      ? allItems.length
      : response?.TotalCount ?? response?.totalCount ?? allItems.length;

    if (allItems.length >= totalCount || items.length < pageSize) {
      break;
    }

    pageNumber += 1;
  }

  officeCollectionFilterDataCache.set(cacheKey, allItems);
  return allItems;
}

export function clearOfficeCollectionFilterDataCache() {
  officeCollectionFilterDataCache.clear();
}

export function* importBulkUpdateFile({ payload, actionType }: any): Generator {
  try {
    let url =
      "distribution/v1/ImportOfficeCollectionMapping/" + payload.UserName;
    const formdata = new FormData();
    formdata.append("file", payload.file);
    const data: any = yield call(api.post, url, formdata);
    yield put(importFileSuccess(data));
  } catch (e: any) {
    yield put(importFileFailed(e.response.data));
    //showErrorNotification(e.response, null);
  }
}

export function deleteOPlanogram(payload: any) {
  let url = OFFICE_COLLECTION_URL.OFFICE_COLLECTION_SAVE;
  return api.delete(url, payload);
}
